export const MAX_PRODUCTS = 3;

export default {
    MAX_PRODUCTS
};
